export const STATUSES = ["New", "Proposal", "Deposit", "Follow-Up Ongoing", "Meeting Follow-Up", "Won", "Lost"];
export const MEETING_STATUSES = ["Show", "No-Show", "Rescheduled By Us", "Rescheduled By Them", "Cancel", "DQ", "Declined"];
export const LOSS_REASONS = ["Price", "Timing", "Partner-Spouse", "Competitor", "Ghosted", "Not Qualified"];
export const SALE_TYPES = ["1-Call Sale", "Follow-Up Sale"];
export const ROLES = ["Setter", "Closer", "Both"];
export const SOURCES = ["Instagram", "Facebook Ads", "Referral", "LinkedIn", "Website", "Cold Call", "YouTube"];

export const STATUS_DOT = {
  New: "bg-sky-500",
  Proposal: "bg-indigo-500",
  Deposit: "bg-amber-500",
  "Follow-Up Ongoing": "bg-violet-500",
  "Meeting Follow-Up": "bg-teal-500",
  Won: "bg-emerald-500",
  Lost: "bg-slate-400",
};

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
